<template>
  <div class="member-wrapper">
    <div class="header">
      <div class='header-content'>
        <div class="setting"><span class='header-right iconfont icon-set right' @click='handleClickSet'></span></div>
        <div class="edit-wrap">
          <div class="l">
            <common-upload-file :fileType='1' method="UpdateUserHeadPath" :picUrl="baseInfo.UserHeadPath" :uploadDisabled="true" class="inline-block" v-if='baseInfo.UserHeadPath'>
            </common-upload-file>
            <div class='default-avatar inline-block' v-else><img src="@assets/images/default_avatar.jpg" /></div>
            <div class="username inline-block">{{baseInfo.SurName}}{{baseInfo.GivenName}}医生</div>
          </div>
          <div class="r">
            <div class='edit-base-info' @click="handleClickBasic">编辑资料</div>
          </div>
        </div>
      </div>
    </div>
    <div class='content'>
      <div class="block header-wrap">
        <span class="l">身份认证</span>
        <span class="r" :class="{'is-red':!$store.getters.user.IsAuthentication}">{{$store.getters.user.IsAuthentication?'已认证':'未认证'}}</span>
      </div>
      <div class="block level" v-if="starCertInfo.StarItem">
        <div class="block-title">我的星级</div>
        <div class="block-con">
          <span class="icon"><img src="../../assets/images/ic_medals.png" /></span>
          <span class="num">LV{{starCertInfo.StarItem.Star}}</span>
          <span class="progress-bar">
            <span class="inner" :style="{width:`${starCertInfo.StarItem.CurrentPercent*100}%`}"></span>
          </span>
        </div>
      </div>
      <div class="block deal" v-if="starCertInfo.CurrentYearCaseCount || starCertInfo.TotalCaseCount">
        <div class="block-title">我的成交</div>
        <div class="block-con">
          <div class="item">
            <img src="../../assets/images/ic_cumulative.png" alt="">
            <div class="message">
              <div class="case-num">{{starCertInfo.TotalCaseCount}}</div>
              <div class="text">累计成交病例数</div>
            </div>
          </div>
          <div class="item">
            <img src="../../assets/images/ic_annual.png" alt="">
            <div class="message">
              <div class="case-num">{{starCertInfo.CurrentYearCaseCount}}</div>
              <div class="text">年度成交病例数</div>
            </div>
          </div>
        </div>
      </div>
      <div class="block cert" v-if="starCertInfo.Certificates">
        <div class="block-title">星级证书
          <a class="view-all" @click="viewAllCerts" v-if="starCertInfo.Certificates.length>4">
            查看全部
            <van-icon name="arrow" />
          </a>
        </div>
        <div class="block-con">
          <div class="item" v-for="(item,index) in starCertInfo.Certificates" :key="index" v-if="index<=3" @click="certDetail(item.Star)">
            <img src="../../assets/images/cert-default.png" />
            <span class="title">{{item.Name}}证书</span>
          </div>
        </div>
      </div>
      <div class="block" v-if='isLoan||isMuscle'>
        <van-cell-group>
          <van-cell is-link to="./apply">
            <div class='title-box' slot="title">
              <span class="custom-text">我的申请</span>
            </div>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="block content-wrap">
        <div class="block-title">常用工具</div>
        <van-cell-group>
          <van-cell is-link to="./interaction" v-if='$store.getters.user.IsAuthentication'>
            <div class='title-box' slot="title">
              <span class='icon-circle in'></span>
              <span class="custom-text">正雅互动</span>
            </div>
          </van-cell>
          <van-cell is-link to="./about-us">
            <div class='title-box' slot="title">
              <span class='icon-circle g'></span>
              <span class="custom-text">关于我们</span>
            </div>
          </van-cell>
          <van-cell value="info@smartee.cn">
            <div class='title-box' slot="title">
              <span class='icon-circle b'></span>
              <span class="custom-text">联系邮箱</span>
            </div>
          </van-cell>
          <van-cell value="400-600-5197" @click="call">
            <div class='title-box' slot="title">
              <span class='icon-circle s'></span>
              <span class="custom-text">联系客服</span>
            </div>
          </van-cell>
          <van-cell is-link to="./tool" v-if="isTuFaceDeformityDiagnosticTool">
            <div class='title-box' slot="title">
              <span class='icon-circle t'></span>
              <span class="custom-text">突面畸形诊断工具</span>
            </div>
          </van-cell>
        </van-cell-group>
      </div>
    </div>
    <!--证书详情-->
    <cert-detail :show="certDetailShow" :level="certLevel" @closeCertDialog="closeCertDialog" v-if="certDetailShow"></cert-detail>
    <router-view />
  </div>
</template>
<script>
import HeadNav from "@/components/member/head-nav";
import CommonUploadFile from '@/components/common/upload';
import CertDetail from './components/cert-detail'
import { Progress } from 'vant'
import store from "@/store";
export default {
  data () {
    return {
      isTuFaceDeformityDiagnosticTool: false,
      params: {
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserRegister'
      },
      baseInfo: {},
      starCertInfo: {
        Certificates: null,
        CurrentYearCaseCount: 0,
        StarItem: null,
        TotalCaseCount: 0
      },
      certViewAll: false,
      certLevel: 0,
      certDetailShow: false,
      isLoan: false,
      isMuscle: false,
    }
  },
  mounted () {
    this.getUserBaseInfo()
    this.getStarCertificateInfo()
    this.getCheckLoanOrthodonticLocate()
  },
  methods: {
    getCheckLoanOrthodonticLocate () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetCheckLoanOrthodonticLocate'
      }).then(res => {
        this.isLoan = res.IsLoan
        this.isMuscle = res.IsMuscle
      })
    },
    getUserBaseInfo () {
      this.$Request(this.params).then(res => {
        this.baseInfo = res || {}
        this.isTuFaceDeformityDiagnosticTool = res.IsTuFaceDeformityDiagnosticTool
      })
    },
    getStarCertificateInfo () {
      this.$Request({
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserRegisterStar'
      }).then(res => {
        this.starCertInfo = res
        // 证书根据星级等级排序
        if (this.starCertInfo.Certificates) {
          this.starCertInfo.Certificates = this.starCertInfo.Certificates.sort((a, b) => { return b.Star - a.Star })
        }
      })
    },
    handleClickBasic () {
      this.$router.push({ path: `/person-data` })
    },
    handleClickSet () {
      this.$router.push({ path: `/setting-page` })
    },
    // 查看所有证书
    viewAllCerts () {
      this.$router.push({ name: 'AllCertificates' })
    },
    certDetail (level) {
      this.certLevel = level
      this.certDetailShow = true
    },
    closeCertDialog () {
      this.certDetailShow = false
    },
    call () {
      location.href = "tel:4006005197"
    }
  },
  components: {
    HeadNav, CommonUploadFile, CertDetail
  }
}
</script>
<style lang="less" scoped>
.member-wrapper {
  max-width: 750px;
  min-height: 100vh;
  width: 100%;
  background: #f8f8f6;
  overflow-y: auto;
  //   padding-bottom: 120px;
  .inline-block {
    display: inline-block;
  }
  .header {
    width: 100%;
    height: 320px;
    background: url("../../assets/images/member-bg.png") top center no-repeat;
    background-size: cover;
    .setting,
    .edit-wrap {
      padding: 0 50px;
    }
    .setting {
      text-align: right;
      padding-top: 50px;
      .iconfont {
        font-size: 50px;
        color: #ffffff;
      }
    }
    .edit-wrap {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .l {
        display: flex;
        align-items: center;
        .username {
          font-size: 36px;
          color: #ffffff;
          font-weight: bold;
          vertical-align: middle;
          margin-left: 20px;
        }
      }
      .r .edit-base-info {
        font-size: 30px;
        color: #ffffff;
        border: 2px solid #ffffff;
        border-radius: 10px;
        padding: 5px 10px;
      }
    }
    /deep/ .upload-image-box img,
    .default-avatar img {
      display: inline-block;
      width: 120px;
      height: 120px;
      border-radius: 50%;
      overflow: hidden;
    }
  }
}
.content {
  position: relative;
  max-width: 750px;
  padding: 0 30px;
  top: -50px;
  .block {
    margin-bottom: 20px;
    padding: 40px 20px;
    border-radius: 16px;
    background: #ffffff;
    .block-title {
      font-size: 32px;
      color: #313131;
      font-weight: bold;
      padding-bottom: 30px;
      border-bottom: 2px solid #f1f1f1;
    }
    .block-con {
      display: flex;
      align-items: center;
      margin-top: 30px;
    }
  }
  .level {
    span {
      display: inline-block;
    }
    .icon img {
      width: 38px;
      height: 50px;
      margin-right: 10px;
    }
    .num {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      height: 35px;
      text-align: center;
      font-size: 26px;
      color: #ffffff;
      background: #e4b565;
      padding: 0;
      border-radius: 30px;
      font-weight: bold;
    }
    .progress-bar {
      width: 70%;
      height: 12px;
      background: #f3f7f6;
      border-radius: 20px;
      line-height: 0;
      overflow: hidden;
      margin-left: 3%;
      .inner {
        background: #e4b565;
        width: 30%;
        height: 100%;
      }
    }
  }
  .deal {
    .block-con {
      display: flex;
      justify-content: space-between;
      img,
      .message {
        display: inline-block;
      }
      img {
        width: 68px;
        height: 68px;
        margin-right: 10px;
      }
      .case-num {
        font-size: 32px;
        color: #359ebb;
      }
      .text {
        color: #333333;
        font-size: 28px;
      }
    }
  }
  .cert {
    .view-all {
      float: right;
      font-size: 28px;
    }
    .van-icon-arrow {
      vertical-align: middle;
    }
    .block-con {
      flex-wrap: wrap;
      .item {
        width: 22%;
        text-align: center;
        margin-bottom: 10px;
        margin-left: 3%;
        img {
          max-width: 100%;
          max-height: 100%;
        }
        .title {
          color: #666666;
        }
      }
    }
  }
  .header-wrap {
    display: flex;
    z-index: 2;
    justify-content: space-between;
    color: #666666;
    font-size: 30px;
    .l {
      color: #333333;
    }
    .r {
      display: flex;
      align-items: center;
      &::after {
        display: inline-block;
        width: 54px;
        height: 50px;
        content: "";
        background: url("../../assets/images/ic_identity_authentication.png")
          top center no-repeat;
        background-size: contain;
        margin-left: 10px;
      }
    }
    .head-right-box {
      position: absolute;
      display: flex;
      width: 200px;
      right: 20px;
      height: 50px;
      top: 100px;
      z-index: 0;
      align-items: center;
      justify-content: flex-end;
      .is-red {
        color: red;
      }
    }
  }
  .content-wrap {
    .title-box {
      display: flex;
      align-items: center;
      .icon-circle {
        display: inline-block;
        width: 72px;
        height: 72px;
        margin-right: 20px;
        &.in {
          background: url("../../assets/images/ic_interactive.png") no-repeat;
          background-size: contain;
        }
        &.g {
          background: url("../../assets/images/ic_about_us.png") no-repeat;
          background-size: contain;
        }
        &.b {
          background: url("../../assets/images/ic_email.png") no-repeat;
          background-size: contain;
        }
        &.s {
          background: url("../../assets/images/ic_customer.png") no-repeat;
          background-size: contain;
        }
        &.t {
          background: url("../../assets/images/ic_tool.png") no-repeat;
          background-size: contain;
        }
      }
    }
    .van-cell {
      padding-left: 0;
      padding-right: 0;
    }
    .van-cell__value {
      color: @blue;
    }
  }
  .apply-btn {
    width: 100%;
    text-align: center;
    font-size: 32px;
    color: #333;
  }
}

.van-cell__value,
.van-cell__right-icon {
  line-height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/member/member-center.vue